/* Tomahawk Jim's navigation safety net — v4.
   Uses Shopify's own localized cart route instead of hard-coding /cart.
   This matters in theme previews and localized storefronts. */
(() => {
  'use strict';

  const getCartUrl = () => (window.routes && window.routes.cart_url) || `${window.Shopify?.routes?.root || '/'}cart`;

  const normalizedText = (element) =>
    `${element?.textContent || ''} ${element?.getAttribute?.('aria-label') || ''}`
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const isViewCartControl = (element) => {
    if (!element) return false;
    if (element.id === 'cart-notification-button' || element.classList?.contains('tj-view-cart-button')) return true;
    const text = normalizedText(element);
    return text === 'view cart' || text.startsWith('view cart ');
  };

  const repairCartNavigation = (root = document) => {
    const cartUrl = getCartUrl();
    const queryRoot = root.querySelectorAll ? root : document;

    queryRoot.querySelectorAll('a').forEach((link) => {
      const raw = link.getAttribute('href') || '';
      const cleaned = raw.trim().replace(/(?:%20)+$/gi, '');
      const looksLikeCart =
        link.id === 'cart-icon-bubble' ||
        isViewCartControl(link) ||
        /(^|\/)cart(?:\?|$)/i.test(cleaned);

      if (looksLikeCart && cleaned !== cartUrl) link.setAttribute('href', cartUrl);
    });

    ['cart-notification-form', 'CartDrawer-Form', 'cart'].forEach((id) => {
      const form = document.getElementById(id);
      if (form) form.setAttribute('action', cartUrl);
    });
  };

  const initialize = () => {
    repairCartNavigation();
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) repairCartNavigation();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
